// extracted by css-extract-rspack-plugin
export default {"ending":"ZIflDh","difficulty":"Hh6Hd5","grade":"xBH4OF"};